/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/naming-convention */
import { EntityColumnOptions } from '../../interfaces/internal';
import { MetadataContainer } from '../container';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function Column(configuration: EntityColumnOptions) {
  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  return function(target: Object, propertyKey: string) {
    let col = MetadataContainer.columns[target.constructor.name];
    col = !col ? [] : col;

    col.push({
      name: propertyKey,
      ...configuration,
    });

    MetadataContainer.columns[target.constructor.name] = [...col];
  };
}
